import { useContext, createContext, useEffect, useState } from 'react';
import {
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged,

} from 'firebase/auth';
import { auth, db } from '../Firebase/firebase'; // Assuming you have this import
import { getDocs, doc,query, where, addDoc, collection } from 'firebase/firestore';

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(null); 
  const [apploading, setAppLoading] = useState(true);
  const [userExists, setUserExists] = useState(false);

  const googleSignIn = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider);
  };

  const logOut = () => {
    signOut(auth);
  };

  const checkUserExists = async (userId,displayName,email,photoURL) => {
    try {
      const userQuery = query(collection(db, 'User'), where('uid', '==', userId));
      const querySnapshot = await getDocs(userQuery);
      if (!querySnapshot.empty) {
        setUserExists(true);
      } else {

        setUserExists(false);
        await addDoc(collection(db,"User"),{
          uid:userId,
          displayName:displayName,
          email:email,
          photoURL:photoURL,
          incomming_request_list:[],
          friendId_list:[],
          friendId_request_list:[],
        })
      }
    } catch (error) {
      console.error("Error checking user existence:", error);
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser); 
      if (currentUser) {
        checkUserExists(currentUser.uid,currentUser.displayName,currentUser.email,currentUser.photoURL);
      } else {
        setUserExists(false);
      }
      setAppLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ googleSignIn, logOut, user, userExists ,apploading}}>
      {children}
    </AuthContext.Provider>
  );
};

export const UserAuth = () => {
  return useContext(AuthContext);
};